import axios from "../axiosInstance"

export const insertNdaInfo = async ({
  legalName,
  email,
  address,
  city,
  state,
  zip,
  country,
  phone,
  dealManagerName,
  dealManagerEmail
}: {
  legalName: string
  email: string
  address: string
  city: string
  state: string
  zip: string
  country?: string
  phone: string
  dealManagerName: string
  dealManagerEmail: string
}) => {
  try {
    const res = await axios.post("/compliance/nda", {
      legalName,
      email,
      address,
      city,
      state,
      zip,
      country,
      phone,
      dealManagerName,
      dealManagerEmail
    })

    const { data } = res
    return data
  } catch (error) {
    console.error("Error inserting NDA information:", error)
    throw error
  }
}

export const insertBcInfo = async ({
  dealId,
  legalName,
  email,
  address,
  city,
  state,
  zip,
  country,
  phone,
  ssn,
  birthDate,
  dealManagerName,
  dealManagerEmail,
  isMarried,
  isUsCitizen,
  spouseName,
  spouseEmail,
}: {
  dealId: number
  legalName: string
  email: string
  address: string
  city: string
  state: string
  zip: string
  country?: string
  phone: string
  dealManagerName: string
  dealManagerEmail: string
  ssn: string
  birthDate: string
  isMarried: string
  isUsCitizen: string
  spouseName?: string
  spouseEmail?: string
}) => {
  try {
    const res = await axios.post("/compliance/bc", {
      dealId,
      legalName,
      clientEmail: email,
      address,
      city,
      state,
      zip,
      country,
      phone,
      dealManagerName,
      dealManagerEmail,
      ssn,
      dob: birthDate,
      isMarried,
      isUsCitizen,
      spouseName,
      spouseEmail,
    })

    const { data } = res
    return data.success
  } catch (error) {
    console.error("Error inserting BC information:", error)
    throw error
  }
}